import { GlobeIcon } from '@radix-ui/react-icons';
import { Select } from '@radix-ui/themes';
import { useTranslation } from '../i18n';
import { LOCALE_OPTIONS, useLocaleStore } from '../stores/localeStore';

interface LanguageSelectorProps {
  className?: string;
  variant?: 'menu' | 'compact';
}

export function LanguageSelector({ className, variant = 'menu' }: LanguageSelectorProps) {
  const { t } = useTranslation();
  const locale = useLocaleStore((state) => state.locale);
  const setLocale = useLocaleStore((state) => state.setLocale);

  if (variant === 'compact') {
    return (
      <div className={`user-menu-language-compact${className ? ` ${className}` : ''}`}>
        <GlobeIcon aria-hidden="true" className="user-menu-language-icon" />
        <Select.Root value={locale} onValueChange={setLocale} size="1">
          <Select.Trigger
            className="user-menu-language-select-compact"
            variant="surface"
            aria-label={t('language.label')}
          />
          <Select.Content position="popper" sideOffset={4} align="end">
            {LOCALE_OPTIONS.map((option) => (
              <Select.Item key={option.code} value={option.code}>
                {option.label}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="user-menu-section-label">{t('language.label')}</div>
      <div className="user-menu-language-row">
        <GlobeIcon aria-hidden="true" className="user-menu-language-icon" />
        <Select.Root value={locale} onValueChange={setLocale} size="2">
          <Select.Trigger className="user-menu-language-select" variant="surface" />
          <Select.Content position="popper" sideOffset={4} align="start">
            {LOCALE_OPTIONS.map((option) => (
              <Select.Item key={option.code} value={option.code}>
                {option.label}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </div>
    </div>
  );
}
